

export class BranchDetailsAlertWithBranchNameOutput implements IBranchDetailsAlertWithBranchNameOutput {
    /** The auto-generated id of the branch details master */
    branch_detail_id!: number;
    /** The branch name */
    branch!: string;

    constructor(data?: IBranchDetailsAlertWithBranchNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branch_detail_id = _data["branch_detail_id"];
            this.branch = _data["branch"];
        }
    }

    static fromJS(data: any): BranchDetailsAlertWithBranchNameOutput {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDetailsAlertWithBranchNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branch_detail_id"] = this.branch_detail_id;
        data["branch"] = this.branch;
        return data; 
    }
}

export interface IBranchDetailsAlertWithBranchNameOutput {
    /** The auto-generated id of the branch details master */
    branch_detail_id: number;
    /** The branch name */
    branch: string;
}

